import React, { useState } from 'react';
import { Badge } from './ui/badge';
import { Building2, BookOpen, Users, ChevronDown, ChevronRight, GraduationCap } from 'lucide-react';

const STYLES = {
    branch: { bar: 'bg-[#064E3B]/5 hover:bg-[#064E3B]/10 px-4 py-3', text: 'text-[#064E3B] font-semibold font-[\'Outfit\']', icon: Building2, badge: 'bg-white text-[#064E3B] border border-[#064E3B]/30' },
    program: { bar: 'bg-[#EDE9FE] hover:bg-[#DDD6FE] px-6 py-3 border-t', text: 'text-[#5B21B6] font-bold text-sm', icon: BookOpen, badge: 'bg-[#5B21B6] text-white hover:bg-[#5B21B6]' },
    class: { bar: 'bg-[#FEF3C7] hover:bg-[#FDE68A] px-10 py-2.5 border-t', text: 'text-[#92400E] font-bold text-sm', icon: Users, badge: 'bg-[#92400E] text-white hover:bg-[#92400E]' },
};

// Collapsible section used for Branch → Program → Class trees (same look as the All Students page).
export const Section = ({ level = 'branch', title, subtitle, teacher, count, children, defaultOpen = true, testId }) => {
    const [open, setOpen] = useState(defaultOpen);
    const st = STYLES[level];
    const Icon = st.icon;
    return (
        <div data-testid={testId}>
            <button type="button" className={`w-full flex flex-wrap items-center gap-2 text-left ${st.bar}`} onClick={() => setOpen(o => !o)} data-testid={testId ? `toggle-${testId}` : undefined}>
                {open ? <ChevronDown className="h-4 w-4" /> : <ChevronRight className="h-4 w-4" />}
                <Icon className="h-4 w-4" />
                <span className={st.text}>{title}</span>
                {subtitle && <span className="text-xs text-[#6B7280]" dir="auto">{subtitle}</span>}
                {teacher && <Badge className="text-xs bg-[#92400E] text-white hover:bg-[#92400E] gap-1"><GraduationCap className="h-3 w-3" />{teacher}</Badge>}
                {count !== undefined && <Badge className={`ml-auto text-xs ${st.badge}`}>{count}</Badge>}
            </button>
            {open && <div className="bg-white">{children}</div>}
        </div>
    );
};

// Groups flat rows into [{branch, programs:[{program, program_id, classes:[{class_id, className, teacher, rows}]}]}]
export const groupByBranchProgramClass = (rows, get) => {
    const branches = new Map();
    rows.forEach(r => {
        const g = get(r);
        const b = branches.get(g.branch) || { branch: g.branch, programs: new Map() };
        const p = b.programs.get(g.program) || { program: g.program, program_id: g.program_id, classes: new Map() };
        const ck = g.class_id || g.className || 'Unassigned';
        const c = p.classes.get(ck) || { class_id: g.class_id, className: g.className || 'Unassigned', teacher: g.teacher, rows: [] };
        c.rows.push(r); p.classes.set(ck, c); b.programs.set(g.program, p); branches.set(g.branch, b);
    });
    const by = (k) => (a, b) => String(a[k]).localeCompare(String(b[k]));
    return [...branches.values()].sort(by('branch')).map(b => ({ ...b, programs: [...b.programs.values()].sort(by('program')).map(p => ({ ...p, classes: [...p.classes.values()].sort(by('className')) })) }));
};
